/* esm.sh - highlight.js@11.11.1/lib/languages/vbscript-html */
function t(n){return{name:"VBScript in HTML",subLanguage:"xml",contains:[{begin:"<%",end:"%>",subLanguage:"vbscript"}]}}export{t as default};
//# sourceMappingURL=vbscript-html.mjs.map